import React, { useState } from "react";
import { createContext } from "react";
import { useLocation } from "react-router-dom";
import locationsMock from "./config.json";

export const LocationsContext = createContext();

const AppProvider = ({ children }) => {
  const locations = locationsMock.locations;
  const [categories, setCategories] = useState(locationsMock.categories);
  const mapConfig = locationsMock.map;
  const center = locationsMock.center;
  const discount = [0.0007, 0.00001];
  const titlePage = locationsMock.title;

  const { pathname } = useLocation();
  const pathToLayer = pathname.includes("blue")
    ? mapConfig.tileLayerBlue
    : mapConfig.tileLayerOrange;
  const tileLayer = `https://api.mapbox.com/styles/${pathToLayer}/tiles/256/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_TECNISA_LARANJA}`;

  function toggleCategoryVisibility(index) {
    const category = categories[index];
    setCategories({
      ...categories,
      [index]: {
        ...category,
        active: !category.active,
      },
    });
  }

  return (
    <LocationsContext.Provider
      value={{
        locations,
        categories,
        toggleCategoryVisibility,
        mapConfig,
        center,
        tileLayer,
        discount,
        titlePage,
      }}
    >
      {children}
    </LocationsContext.Provider>
  );
};

export default AppProvider;
